export default "__VITE_ASSET__Decqt8lO__"